import React from 'react';

/**
 * Error boundary kolem celé Flotily — chytí render-time errors (typicky React
 * minified errors jako #300) a místo prázdné stránky / spadlé Reactu vypíše
 * čitelnou hlášku včetně komponentního stacku, podle kterého je hned vidět,
 * která komponenta padá.
 *
 * componentDidCatch(error, info) — info.componentStack je multilínový text
 * s komponentní hierarchií ve chvíli erroru; nepotřebujeme sourcemapu.
 *
 * Kontextové informace (URL, viewport, userAgent) pošleme i do console
 * přes group, aby šlo při refrendingu přesně určit, co se dělo.
 */
export default class FlotilaErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        this.setState({ info });
        try {
            console.group('%c[FLOTILA ERROR]', 'color:#fff;background:#EF4444;padding:2px 6px;border-radius:3px;font-weight:700;');
            console.error(error);
            console.log('Component stack:', info?.componentStack);
            console.log('URL:', window.location.href);
            console.log('Viewport:', window.innerWidth, '×', window.innerHeight);
            console.log('UA:', navigator.userAgent);
            console.groupEnd();
        } catch {}
    }

    handleReset = () => {
        this.setState({ error: null, info: null });
    };

    render() {
        if (!this.state.error) return this.props.children;
        const { error, info } = this.state;
        const stackText = info?.componentStack || '(žádný component stack)';
        return (
            <div style={{
                padding: 24, margin: 24,
                background: 'rgba(239,68,68,0.08)',
                border: '1px solid rgba(239,68,68,0.30)',
                borderRadius: 9,
                color: 'var(--text-primary)',
                fontSize: 13, lineHeight: 1.5,
                fontFamily: 'system-ui, -apple-system, sans-serif',
            }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: '#EF4444', marginBottom: 8 }}>
                    Flotila — chyba renderingu
                </div>
                <div style={{ marginBottom: 12, color: 'var(--text-secondary)' }}>
                    {String(error?.message || error)}
                </div>
                <details>
                    <summary style={{ cursor: 'pointer', fontWeight: 600, marginBottom: 8 }}>
                        Component stack (pošli prosím tento blok zpět při hlášení chyby)
                    </summary>
                    <pre style={{
                        whiteSpace: 'pre-wrap', wordBreak: 'break-all',
                        background: 'rgba(0,0,0,0.20)', color: '#FFC857',
                        padding: 12, borderRadius: 6, fontSize: 11,
                        maxHeight: 400, overflow: 'auto',
                        margin: '8px 0',
                    }}>
{stackText}
                    </pre>
                </details>
                <button type="button" onClick={this.handleReset} style={{
                    marginTop: 12,
                    padding: '8px 14px',
                    background: SECTION_COLOR_FALLBACK,
                    color: '#0A0612',
                    border: 'none',
                    borderRadius: 6,
                    fontWeight: 700,
                    fontSize: 13,
                    cursor: 'pointer',
                }}>
                    Zkusit znovu
                </button>
            </div>
        );
    }
}

const SECTION_COLOR_FALLBACK = '#0CC0DF';
